import convertStylesStringToObject from '../utils/convertStylesStringToObject';

export const CheckerBoardBackground = () => {
  const styleString =
    'background-image: linear-gradient(45deg, #f4f4f4 25%, transparent 25%), linear-gradient(-45deg, #f4f4f4 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #f4f4f4 75%), linear-gradient(-45deg, transparent 75%, #f4f4f4 75%); background-position: 0 0, 0 15px, 15px -15px, -15px 0; background-size: 30px 30px;';
  return (
    <div
      className={`bg-white h-full overflow-hidden absolute inset-0 w-full shadow-xl`}
      style={convertStylesStringToObject(styleString)}
    />
  );
};
